import { Injectable, inject, signal, computed } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { constants } from '../../../constants/constants';
import { SessionExpirationModal } from '@rccl/global-login/loader';

@Injectable({
  providedIn: 'root',
})
export class SessionExpirationModalService {
  private readonly authenticationService = inject(AuthenticationService);
  private readonly routes = constants.ROUTES;

  private readonly showWarningModal = signal<boolean>(true);
  private readonly minutesToExpiration = signal<number>(20);
  private readonly showExpiredSessionModal = signal<boolean>(true);

  /**
   * @description Session expiration modal configuration options as a computed signal.
   */
  public readonly sessionExpirationModalOption = computed<string>(() =>
    JSON.stringify({
      showWarningModal: this.showWarningModal(),
      minutesToExpiration: this.minutesToExpiration(),
      showExpiredSessionModal: this.showExpiredSessionModal()
    } as unknown as SessionExpirationModal)
  );

  /**
   * @description This function is called when the session is not extended.
   */
  public onSessionNotExtended(): void {
    this.authenticationService.endSession({
      exitUrl: `${this.routes.GUEST_ACCOUNT + this.routes.SIGN_IN}`,
      logoutFromGA: true
    });
  }

  /**
   * @description This function is called when the expired session modal (it should be enabled) is requested to sign in.
   */
  public onSessionTimeoutModalRequestSignIn(): void {
    this.authenticationService.endSession({
      exitUrl: `${this.routes.GUEST_ACCOUNT + this.routes.SIGN_IN}`,
      logoutFromGA: true
    });
  }
}
